/* global axios */
import ApiClient from '../ApiClient';

class ZaloChannel extends ApiClient {
  constructor() {
    super('zalo', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new ZaloChannel();
